import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

class Supplier {
  create = async (supplier: any) => {
    await axios({
      method: "post",
      url: `${API_URL}supplier`,
      data: supplier,
    }).catch((e) => {
      const { message } = e.response.data;
      if (message.errorInfo) throw message.errorInfo[2];
      else throw e.message;
    });
  };

  edit = async (supplier: any, code: any) => {
    await axios({
      method: "put",
      url: `${API_URL}supplier/${code}`,
      data: supplier,
    }).catch((e) => {
      const { message } = e.response.data;
      if (message.errorInfo) throw message.errorInfo[2];
      else throw e.message;
    });
  };

  get = async (code: any) => {
    const response = await axios.get<any>(`${API_URL}supplier/${code}`,
    ).catch((e) => {
      throw e.message;
    });
    return response.data.supplier;
  };

  getAll = async () => {
    const response = await axios.get<any>(`${API_URL}supplier`,
    ).catch((e) => {
      throw e.message;
    });
    return response.data.supplier;
  };

  search = async (keyword: any) => {
    const response = await axios.get<any>(`${API_URL}supplier-search/${keyword}`,
    ).catch((e) => {
      throw e.message;
    });
    return response.data.supplier;
  };
}
export default new Supplier();
